import { render, staticRenderFns } from "./addCommunityPublicityList.vue?vue&type=template&id=6fad3082&scoped=true"
import script from "./addCommunityPublicityList.vue?vue&type=script&lang=js"
export * from "./addCommunityPublicityList.vue?vue&type=script&lang=js"
import style0 from "./addCommunityPublicityList.vue?vue&type=style&index=0&id=6fad3082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fad3082",
  null
  
)

export default component.exports